import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()

const state = {
  /*
     * 生产日期录入
     * */
  rollsHomeworkMark: 0,
  productionDateEntryList: [], // 生产日期录入列表,
  productionDateDetailList: [], // 未/已配置的生产日期详情列表

  /*
     * 上架单
     * */
  productDateMark: 0,
  putawayList: [], // 上架单列表
  shelvesOrderInfo: null, // 上架单列表详情
  productList: [], // 新增获取商品列表
  supplierSelect: [], // 供应商 - 下拉框
  /*
     * 快速移库
     * */
  moveTaskList: [], // 快速移库列表
  moveTaskDetail: [], // 移库任务详情
  qualityChangeList: {}, // 品质调整
  queryDateLogPageList: {}
}

const actions = {
  /*
     * 生产日期录入
     * */
  // 生产日期录入列表
  [types.GETPRODUCTDATELIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/productionDate/getProductionDateList', params).then(data => {
        context.commit(types.GETPRODUCTDATELIST, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取未配置的生产日期详情列表
  [types.GETUNPRODUCTDATEDETAILLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/productionDate/getProductionDateDeploy', params).then(data => {
        data.obj.forEach(x => {
          x.batchList = [{
            ytgbId: '', // 批次id
            ytgbProductionTime: '', // 生产日期
            ytgbNormal: 0, // 批次正常品
            ytgbBroken: 0, // 批次破损品
            validUntil: ''
          }]
        })
        context.commit(types.GETUNPRODUCTDATEDETAILLIST, data)
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取已配置的生产日期详情列表
  [types.GETPRODUCTDATEDETAILLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/productionDate/getProductionDateInfo', params).then(data => {
        context.commit(types.GETPRODUCTDATEDETAILLIST, data)
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 保存生产日期配置
  [types.SAVEPRODUCTIONDATECONFIGURATION] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/productionDate/saveProductionDateDeploy', params, 'application/json').then(data => {
        context.commit(types.SAVEPRODUCTIONDATECONFIGURATION, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  /*
     * 上架单
     * */
  // 获取上架单列表
  [types.GETSHELVESORDERLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/shelvesOrder/getShelvesOrderList', params).then(data => {
        context.commit(types.GETSHELVESORDERLIST, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取上架单列表
  [types.CANCELSHELVESORDER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/shelvesOrder/cancelShelvesOrder', params).then(data => {
        context.commit(types.CANCELSHELVESORDER, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取上架单列表详情
  [types.GETSHELVESORDERINFO] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/shelvesOrder/getShelvesOrderInfo', params).then(data => {
        context.commit(types.GETSHELVESORDERINFO, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取商品列表
  [types.GETPRODUCTLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/shelvesOrder/getShelvesDocumentsGoodList', params).then(data => {
        context.commit(types.GETPRODUCTLIST, data)
        resolve(data.obj)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 保存新增上架单
  [types.SAVESHELVESORDER] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/shelvesOrder/addShelvesOrder', params, 'application/json').then(data => {
        context.commit(types.SAVESHELVESORDER, data)
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取供应商 - 下拉框
  [types.GETSHELVESDOCUMENTSSUPPLIERSELECT] (context, params) {
    http.fetch('/api/supplier/getShelvesDocumentsSupplierSelect', params).then(data => {
      context.commit(types.GETSHELVESDOCUMENTSSUPPLIERSELECT, data)
    })
  },
  /*
     * 快速移库
     * */
  // 快速移库列表
  [types.GETMOVETASKLIST] (context, params) {
    http.fetch('/api/move/getMoveTaskList', params).then(data => {
      context.commit(types.GETMOVETASKLIST, data)
    })
  },
  [types.GETMOVETASKDETAIL] (context, params) {
    http.fetch('/api/move/getMoveTaskDetail', params).then(data => {
      context.commit(types.GETMOVETASKDETAIL, data)
    })
  },
  /*
  * 品质调整
  * */
  [types.GETQUALITYLOG] (context, params) {
    http.fetch('/api/qualityLog/qualityLogPage', params).then(data => {
      context.commit(types.GETQUALITYLOG, data)
    })
  },
  /**
   * 生产日期调整
   */
  [types.GETDATELOG] (context, params) {
    http.fetch('/api/dateLog/queryDateLogPageList', params).then(data => {
      context.commit(types.GETDATELOG, data)
    })
  }
}

const mutations = {
  /*
   * 生产日期录入
   * */
  // 生产日期录入列表
  [types.GETPRODUCTDATELIST] (state, data) {
    state.productionDateEntryList = data.obj
  },
  // 未配置的生产日期详情列表
  [types.GETUNPRODUCTDATEDETAILLIST] (state, data) {
    state.productionDateDetailList = data.obj
  },
  // 已配置的生产日期详情列表
  [types.GETPRODUCTDATEDETAILLIST] (state, data) {
    state.productionDateDetailList = data.obj
  },
  // 保存生产日期配置
  [types.SAVEPRODUCTIONDATECONFIGURATION] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.rollsHomeworkMark = 1
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
    }
  },
  /*
   * 上架单
   * */
  // 获取上架单列表
  [types.GETSHELVESORDERLIST] (state, data) {
    state.putawayList = data.obj
  },
  // 获取上架单列表
  [types.CANCELSHELVESORDER] (state, data) {
    if (data.code === 200) {
      // state.rollsHomeworkMark = 1
      vue.$message({
        showClose: true,
        message: '取消成功',
        type: 'success'
      })
    }
  },
  // 获取上架单列表详情
  [types.GETSHELVESORDERINFO] (state, data) {
    state.shelvesOrderInfo = data.obj
  },
  // 获取商品列表
  [types.GETPRODUCTLIST] (state, data) {
    let D = data.obj
    D.forEach(x => {
      x.brokenAllNum = 0
      x.allNum = 0
    })
    state.productList = D
  },
  // 保存上架单列表
  [types.SAVESHELVESORDER] (state, data) {
    console.log(data)
    if (data.code === 200) {
      state.productDateMark = 1
      vue.$message({
        showClose: true,
        message: '保存成功',
        type: 'success'
      })
    }
  },
  // 获取供应商 - 下拉框
  [types.GETSHELVESDOCUMENTSSUPPLIERSELECT] (state, data) {
    state.supplierSelect = data.obj
  },
  /*
   * 快速移库
   * */
  // 获取列表
  [types.GETMOVETASKLIST] (state, data) {
    state.moveTaskList = data.obj
    // console.log(state.moveTaskList, 'state.moveTaskList')
  },
  [types.GETMOVETASKDETAIL] (state, data) {
    state.moveTaskDetail = data.obj
    if (state.moveTaskDetail == null) {
      state.moveTaskDetail = []
    }
    console.log(state.moveTaskDetail, 'state.moveTaskDetail')
  },
  [types.GETQUALITYLOG] (state, data) {
    state.qualityChangeList = {
      rows: data.obj.records,
      total: data.obj.total
    }
  },
  [types.GETDATELOG] (state, data) {
    state.queryDateLogPageList = {
      rows: data.obj.records,
      total: data.obj.total
    }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/rollsHomework/index.js